import { createContext } from "react";
import { bnIdentityGenerator } from "../hooks/useBNIdentityProvider";
export var BNIdentityCtx = createContext(bnIdentityGenerator(""));
//# sourceMappingURL=BNIdentityCtx.js.map